import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Inside } from '../../models/inside';
import { InsideService } from '../../services/inside.service';
import { ListForm } from '../../../../base/controlers/list-form';
import { PagedListForm } from '../../../../base/controlers/paged-list-form';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, tap } from 'rxjs/operators';


@Component({
  selector: 'app-inside-list',
  templateUrl: './inside-list.component.html',
  styleUrls: ['./inside-list.component.css']
})
export class InsideListComponent extends PagedListForm<Inside> implements OnInit, AfterViewInit {
  public displayedColumns = ['actions','code','name', 'price'];
  @ViewChild('search',{static:true}) search: ElementRef;
  constructor(
    protected insideService: InsideService,
    protected router:Router        
  ) {
    super(insideService,'/plasard-measurement/inside',router,null,'code',true);
   }

  ngOnInit() {
    super.ngOnInit();
  }
  ngAfterViewInit() {
    // server-side search
    fromEvent(this.search.nativeElement,'keyup')
        .pipe(
            filter(Boolean),
            debounceTime(300),
            distinctUntilChanged(),
            tap((_) => {
              const filter = this.search.nativeElement.value.trim();
              let query = null;
              if(filter){
                query = `contains(code, '${filter}') or contains(name, '${filter}')`;
              }
              this.onFilter(query);
            })
        )
        .subscribe();
    }
}